// extracted by mini-css-extract-plugin
module.exports = {"Line":"Tabs_Line__1oNnk","Span":"Tabs_Span__7Vkps","TabItem":"Tabs_TabItem__nKQLd","ActiveNavButton":"Tabs_ActiveNavButton__1vprI"};